import React from 'react';
import Button from '../../../../../components/Button';
import FixedBottomNavBar from '../../../../../components/FixedBottomNavBar';
import './TagManagementTrendKeywordNavbar.scss';

const TagManagementTrendKeywordNavbar = (props) => {
  const { tagTrendKeywordPreview } = props;

  return (
    <FixedBottomNavBar className="tag-management-trend-keyword-navbar">
      <div className="button-group">
        <div className="left">
          <Button color="light" text="미리보기" onClick={() => tagTrendKeywordPreview()} />
        </div>

        <div className="right"></div>
      </div>
    </FixedBottomNavBar>
  );
};

export default TagManagementTrendKeywordNavbar;
